<script lang="ts" setup>

interface Props{
  message: FormattedMessage;
}

defineProps<Props>();

const { t, d } = useEkI18n();

const emits = defineEmits<{ delete: [], goToWorksheet: [FormattedMessage], goToExpense: [FormattedMessage] }>();

</script>

<template>
  <p
    :id="message.Id.toString()"
    class="ion-text-center date"
  >
    {{ d(message.Timestamp, 'dateFormats.writtenDayMonthYearTime') }}
  </p>

  <IonCard>
    <IonCardHeader v-if="message.Project !== null">
      <IonCardTitle>
        {{ message.Project.Name }}
      </IonCardTitle>
      <IonCardSubtitle>
        {{ message.Project.Reference }}
      </IonCardSubtitle>
    </IonCardHeader>

    <IonCardContent class="message">
      <template
        v-for="(text, index) in message.splitMessageText"
        :key="index"
      >
        <span v-if="index % 2 === 0">
          {{ text }}
        </span>
        <a
          v-else
          :href="text"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ text }}
        </a>
      </template>
    </IonCardContent>

    <IonToolbar color="card-background">
      <IonButtons slot="start">
        <IonButton
          color="primary"
          @click="emits('delete')"
        >
          <IonIcon
            slot="icon-only"
            class="fa-light fa-fw fa-trash-can"
          />
        </IonButton>
      </IonButtons>
      <IonButtons slot="end">
        <IonButton
          v-if="message.WorksheetId"
          color="primary"
          @click="emits('goToWorksheet', message)"
        >
          {{ t('buttons.goToWorksheet') }}
        </IonButton>
        <IonButton
          v-if="message.ExpenseId"
          color="primary"
          @click="emits('goToExpense', message)"
        >
          {{ t('buttons.goToExpense') }}
        </IonButton>
      </IonButtons>
    </IonToolbar>
  </IonCard>
</template>

<style scoped>
.message{
  white-space: pre-wrap;
}

a:visited{
  color: color-mix(in oklab, var(--ion-color-primary) 40%, var(--ion-color-danger));
}

.date {
  color: var(--ion-color-medium);
  font-size: small;
}
</style>
